import { Component, OnInit, ChangeDetectionStrategy, ViewChild, EventEmitter, ViewEncapsulation, AfterViewInit, OnDestroy } from '@angular/core';
import { SystemService } from '../../../../services/system.service';
import { ActivatedRoute, Params } from '@angular/router';
import { ProductService } from '../../../product/product.service';
import { NotificationService } from 'src/app/shared/notification.service';
import { AuthService } from 'src/app/services/auth.service';
import { User } from 'src/app/auth/user';
import { combineLatest, Observable, Subject, Subscription, of } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ColumnSetting } from 'src/app/layout/table-standard-layout/table-standard-layout.component';
import { ActionButtonEvent } from 'src/app/layout/action-button-toolbar/action-button-toolbar.component';
import { CommonPopup } from '../../../common-popup/common-popup';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-extrastockcontroll',
  templateUrl: './extrastockcontroll.component.html',
  styleUrls: ['./extrastockcontroll.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None
})
export class ExtraStockcontrollComponent implements OnInit, OnDestroy {

  siteId: string;
  systemId: string;
  fragment: string;
  user: User;
  product$;
  combObs$ = new Subject;

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  // 'updatedOn', 'createdOn', 'createdBy', 'detail', 'status', 'action'
  // displayedColumns: string[] = ['name', 'maxLimit', 'threshold', 'quantity', 'fillStatus'];
  columnSettings: ColumnSetting[] = [
    {
      columnId: 'name',
      name: 'Product name',
      maxLengthOnMobile: 15
    },
    // {
    //   columnId: 'productNumber',
    //   name: 'Product #',
    //   hideOnMobile: true
    // },
    {
      columnId: 'overview',
      name: 'Overview',
      hideOnMobile: true,
      // align: 'center'
    },
    // {
    //   columnId: 'machineName',
    //   name: 'Machine',
    //   hideOnMobile: true
    // },
    {
      columnId: 'quantity',
      name: 'Quantity',
      // align: 'right'
    },
    // {
    //   columnId: 'selection',
    //   name: 'Diff.',
    //   hideOnMobile: true
    //   // align: 'right'
    // },
    // {
    //   columnId: 'structuralQty',
    //   name: 'Structural Qty',
    //   hideOnMobile: true

    //   // align: 'right'
    // },
    {
      columnId: 'maxLimit',
      name: 'Maximum limit',
      hideOnMobile: true,
      // align: 'right'
    },
    // {
    //   columnId: 'threshold',
    //   name: 'Threshold',
    //   hideOnMobile: true,
    //   // align: 'right'

    // },
    // {
    //   columnId: 'fillStatus',
    //   name: 'Fill status',
    //   hideOnMobile: true
    //   // align: 'center'
    // }
  ]

  sortingArray = ['Product name', 'Product #', 'Channel #', 'Machine', 'Quantity', 'Diff.', 'Structural Qty', 'Maximum limit', 'Threshold', 'Fill status']

  dataSource$: Observable<MatTableDataSource<any>>;
  projects$: Observable<any>;
  // siteId: string;
  projects: MatTableDataSource<any>;
  haveFilter = false;

  rowActionButtons: any[];
  topbarActionButton: any[];
  onEdit: EventEmitter<ActionButtonEvent>;
  onAdd: EventEmitter<ActionButtonEvent>;
  onMinus: EventEmitter<ActionButtonEvent>;
  onTransactionsSubscription: Subscription;
  onDeleteSubscription: Subscription;
  onEditSubscription: Subscription;
  onAddSubscription: Subscription;
  onMinusSubscription: Subscription;
  getStock$ = new Observable
  getStockSub = new Subscription

  constructor(private route: ActivatedRoute,
    public dialog: MatDialog,
    private productService: ProductService,
    private sysService: SystemService,
    private notifierService: NotificationService,
    public auth: AuthService) {

    combineLatest(this.route.parent.params, this.route.params).subscribe(params => {

      this.siteId = params[0]['siteId']
      this.systemId = params[1]['systemId']
      this.getStock$ = this.sysService.getStockData$(this.siteId, this.systemId)
        .pipe(map(async array => {

          return await Promise.all((array as any).map(async obj => {
            let product = await this.productService.getProductById(obj['productId']) // array[0].filter(t => t['id'] === obj['productId'])[0]
            //  console.log(product)
            let threshold = product ? product['threshold'] : 0;
            // console.log(JSON.stringify(obj))
            return {
              ...obj,
              quantity: obj.quantity.toString(),
              ...product as object,
              //  name: obj.productName ? obj.productName : product['name'],
              selection: obj.selection,
              maxLimit: obj.maxLimit ? obj.maxLimit : product['maxLimit'],
              // overview: obj.quantity ? obj.quantity.toString() +"/"+  obj.maxLimit : obj.quantity.toString() +"/"+ product['maxLimit'],
              fillStatus: threshold >= obj['quantity'] ? 'Low' : 'Ok',
              diff: ((obj.maxLimit ? obj.maxLimit : product['maxLimit']) - obj.quantity).toString(),
              structuralQtyPerUnit: obj.structuralQtyPerUnit ? obj.structuralQtyPerUnit : 0,
              structuralQty: obj.structuralQtyPerUnit ? (obj.quantity * obj.structuralQtyPerUnit).toFixed(2) : obj.quantity.toFixed(2),
              index: obj.machineName + '  ' + (Number(obj.selection) + 1)
            }
          }))
        }))
      this.getStockSub = this.getStock$.subscribe(d => {

        (d as any).then(async da => {
          // let records = await this.sortArray(da)
          let list = []
          da.forEach(a => {
            let findAvailableProduct = list.find(b => b.id == a.id);

            if (findAvailableProduct) {
              let index = list.indexOf(findAvailableProduct);
              list[index].quantity = (Number(list[index].quantity) + Number(a.quantity)).toString();
              list[index].maxLimit = Number(list[index].maxLimit) + Number(a.maxLimit);
              list[index].overview = list[index].quantity.toString() + "/" + list[index].maxLimit.toString();
              list[index].selection = list[index].selection + "," + Number(a.selection);
            } else {
              a.overview = a.quantity.toString() + "/" + a.maxLimit.toString();
              a.selection =a.machineName+ "-"+a.selection.toString();

              list.push(a)
              list.sort((a, b) => a.name.localeCompare(b.name));
            }
          })
          this.combObs$.next(list)
        })
      })
    })


    this.onAdd = new EventEmitter<ActionButtonEvent>();
    this.onMinus = new EventEmitter<ActionButtonEvent>();
    // this.siteId = this.route.parent.snapshot.params['siteId'];

    // this.rowActionButtons = [
    //   { icon: 'remove_circle', tooltip: 'Edit', eventEmitter: this.onMinus },
    //   { icon: 'add_circle', tooltip: 'Edit', eventEmitter: this.onAdd },
    // ]
  }

  ngOnInit() {
    // this.product$ = this.productService.data; //this.productService.getProducts();

    this.onAddSubscription = this.onAdd.subscribe(event => {
      this.updateQuantity(event.eventData, 1);
    });
    this.onMinusSubscription = this.onMinus.subscribe(event => {
      this.updateQuantity(event.eventData, -1);
    });
  }



  editPopup(obj) {
    const dialogRef = this.dialog.open(CommonPopup, {
      disableClose: true,
      width: '500px',
      data: {
        siteId: this.siteId,
        text: '',
        formData: {
          title: `Update`,
          inputFeilds: [
            {
              labelName: "Name of product",
              name: "name",
              required: true,
              disabled: false,
              type: "text",
              value: obj.name,
              specialText: ""
            }, {
              labelName: "Structural Qty",
              name: "structuralQtyPerUnit",
              required: false,
              type: "number",
              disabled: false,
              value: obj.structuralQtyPerUnit ? obj.structuralQtyPerUnit : 1,
              specialText: ""
            }, {
              labelName: "Maximum limit",
              name: "maxLimit",
              required: true,
              disabled: false,
              type: "text",
              value: obj.maxLimit,
              specialText: ""
            }, {
              labelName: "Threshold",
              name: "threshold",
              required: true,
              type: "text",
              disabled: true,
              value: obj.threshold,
              specialText: ""
            },
            {
              labelName: "Quantity",
              name: "quantity",
              required: true,
              type: "number",
              value: obj.quantity,
              specialText: ""
            }
          ],
          buttons: [
            {
              name: "Update",
              type: "submit",
              color: "primary",
              validate: true
            }
          ]
        }
      }
    });

    dialogRef.afterClosed().subscribe(async result => {

      if (result) {
        console.log(result.value)
        obj.newValue = result.value.quantity + obj.quantity
        obj.quantity = result.value.quantity;
        obj.productName = result.value.name
        obj.maxLimit = result.value.maxLimit
        obj.structuralQtyPerUnit = result.value.structuralQtyPerUnit
        if (Number(obj.quantity) > Number(obj.maxLimit)) {
          this.notifierService.showNotification('error', `Maximum limit is ${obj.maxLimit}`);
        }
        else {
          let response = await this.sysService.updateQuantity(this.siteId, this.systemId, obj);
          if (response && response.success) {
            this.notifierService.hideAllNotifications();
            this.notifierService.showNotification('success', response.message);
            obj.quantity = Number(obj.quantity);
          } else {
            this.notifierService.showNotification('error', response?.message || "Please try again");
          }
          //   obj.newValue = 0;
        }
      }
    });

  }


  async updateQuantity(result, value) {
    let obj = {

    };
    if (result) {

      console.log(this.siteId, this.systemId, result, value)
      obj['newValue'] = Number(result.quantity) + value
      obj['quantity'] = Number(result.quantity) + value;
      obj['productName'] = result.name;
      obj['productId'] = result.productId;
      obj['maxLimit'] = result.maxLimit
      obj['channelId'] = result.channelId

      obj['structuralQtyPerUnit'] = result.structuralQtyPerUnit
      if (Number(obj['quantity']) > Number(obj['maxLimit'])) {
        this.notifierService.showNotification('error', `Maximum limit is ${obj['maxLimit']}`);
      }
      else {
        let response = await this.sysService.updateQuantity(this.siteId, this.systemId, obj);
        if (response && response.success) {
          this.notifierService.hideAllNotifications();
          this.notifierService.showNotification('success', response.message);
          obj['quantity'] = Number(obj['quantity']);
        } else {
          this.notifierService.showNotification('error', response?.message || "Please try again");
        }
        //   obj.newValue = 0;
      }
    }
  }

  sortArray(array) {
    return new Promise((res, rej) => {
      let temp = 0;
      for (let i = 0; i < array.length; i++) {
        for (let j = i; j < array.length; j++) {
          if (array[j]['selection'] < array[i]['selection']) {
            temp = array[j];
            array[j] = array[i];
            array[i] = temp;
          }
          if (array[j]['machineName'] < array[i]['machineName']) {
            temp = array[j];
            array[j] = array[i];
            array[i] = temp;

          }

        }
      }
      let count = 11
      array.forEach((element, index) => {
        if (count % 10 == 0) count++

        element.index = count
        count++
      });
      // for (var i = 11; i < array.length; i++) {
      //   array[i].index = i
      // }
      res(array);
    })

  }

  ngOnDestroy(): void {
    this.getStockSub.unsubscribe()
  }




}
